import type { TourSpec } from "./types";

export const settingsDiscordTour: TourSpec = {
  id: "settings-discord",
  version: 1,
  buildSteps: (t) => [
    {
      target: '[data-tour="discord-link-button"]',
      title: t("settingsDiscord.link.title"),
      content: t("settingsDiscord.link.body"),
      placement: "bottom",
      skipBeacon: true,
    },
    {
      target: '[data-tour="discord-verification"]',
      title: t("settingsDiscord.verification.title"),
      content: t("settingsDiscord.verification.body"),
      placement: "top",
    },
    {
      target: '[data-tour="discord-notification-settings"]',
      title: t("settingsDiscord.notifications.title"),
      content: t("settingsDiscord.notifications.body"),
      placement: "top",
    },
    {
      target: '[data-tour="discord-webhook-categories"]',
      title: t("settingsDiscord.webhooks.title"),
      content: t("settingsDiscord.webhooks.body"),
      placement: "top",
    },
  ],
};
